import React from 'react';
import PropTypes from 'prop-types';

import { Field } from '@klarna/bubble-ui';

class PersonalIdInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editing: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  onChange(value) {
    this.props.onTouchPersonalId();

    if (!this.props.prefix && value) {
      return this.props.onChange(value);
    } else if (value.startsWith(this.props.prefix)) {
      return this.props.onChange(value.replace(this.props.prefix, ''));
    } else if (!value) {
      // this allows (CTRL + A -> DELETE) to work
      this.props.onChange('');
    }
  }

  onFocus(event) {
    this.props.onTouchPersonalId();
    this.setState({ editing: true });

    if (this.props.onFocus) {
      this.props.onFocus(event);
    }
  }

  onBlur(event) {
    this.setState({ editing: false });

    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
  }

  render() {
    const { editing } = this.state;
    const {
      prefix = '',
      mask = '**********',
      hasPersonalId,
      isPersonalIdPristine,
      onTouchPersonalId,
      value: stateValue,
      ...inputProps
    } = this.props;

    const typedValue = prefix ? stateValue.replace(prefix, '') : stateValue;
    const finalPrefix = prefix && (typedValue || editing) ? prefix : '';
    const value = isPersonalIdPristine && hasPersonalId ? mask : `${finalPrefix}${typedValue}`;

    return (
      <Field
        {...inputProps}
        value={value}
        onChange={this.onChange}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        isUnderlined
      />
    );
  }
}

PersonalIdInput.propTypes = {
  ...Field.propTypes,
  onTouchPersonalId: PropTypes.func.isRequired,
  hasPersonalId: PropTypes.bool,
  isPersonalIdPristine: PropTypes.bool,
  mask: PropTypes.string,
  prefix: PropTypes.string,
};

export default PersonalIdInput;
